//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

type AuthType = Opaque<string, 'AuthType'>;

function authTypeFactory(authType: string) {
  return authType as AuthType;
}

const AuthType = Object.assign(authTypeFactory, {
  UserPassword: authTypeFactory('user_password'),
  GoogleSSO: authTypeFactory('google_sso'),
  BVOkta: authTypeFactory(CURALATE_ENV.BV_AUTH_TYPE),
});

export default AuthType;
